export { default, NoForwardRefTextarea, type TextareaProps } from './Textarea';
